export default __webpack_public_path__ + "static/omni-2-762ebdcecc25c22da63f3c68d74133ab.webp";